import React from 'react';

import Card from '../../components/Card/Card';
import GqlQueryWrapper from '../../components/GqlQueryWrapper/GqlQueryWrapper';
import Table from '../../components/Table/Table';
import TablePreRender from '../../components/Table/Table.prerender';
import TitleWithDescription from '../../components/TitleWithDescription/TitleWithDescription';

import styles from './AccountMinimums.css';

import { ACCOUNT_MINIMUMS, NO_LOAD_FUND } from './queries';
import {
    accountMinimumsUtil,
    loadFundUtil,
    disclaimerNumbersAcctMinimums
} from './util';

const AccountMinimums = ({ ticker, moneyMarket, iClass, bond }) => (
    <Card>
        <GqlQueryWrapper
            query={ACCOUNT_MINIMUMS}
            variables={{ ticker }}
            dataFunc={accountMinimumsUtil(iClass, moneyMarket, bond)}
            placeholder={() => <TablePreRender />}
        >
            {({ data: { data, title } }) => (
                <div className="container">
                    <TitleWithDescription title={title} />
                    <Table data={{ data }} rowBars />
                    {iClass && (
                        <div className="disclaimer">
                            <sup>*</sup>Please see the prospectus for more
                            information about investment minimums.
                        </div>
                    )}
                    <div className="disclaimer">
                        <sup>
                            {disclaimerNumbersAcctMinimums(
                                iClass,
                                moneyMarket,
                                bond
                            )}
                        </sup>
                        Per account per transaction after opening minimum is
                        satisfied.
                    </div>
                </div>
            )}
        </GqlQueryWrapper>
        <GqlQueryWrapper
            query={NO_LOAD_FUND}
            variables={{ ticker }}
            dataFunc={loadFundUtil}
        >
            {({ data: { data, title } }) => (
                <div className="container">
                    <TitleWithDescription title={title} />
                    <Table data={{ data }} rowBars />
                </div>
            )}
        </GqlQueryWrapper>
        <style jsx>{styles}</style>
    </Card>
);

export default AccountMinimums;
